module.exports = __webpack_public_path__ + "static/media/pare-gif.9cda51ec.gif";